'use client';

import React from 'react';

import {Image} from '@udemy-v2/react-core-components';

import {Heading} from '@/lib/heading-level';
import {
    DynamicWebContentPageType,
    useDynamicWebContentPartnersBannerQuery,
} from '@/generated/graphql';

import {useCmsPreviewContent} from '../../data/hooks/use-cms-preview-content';
import {adaptPartnersBannerData} from '../../data/parse';
import type {PartnersBannerData} from '../../data/types';
import styles from './partners-banner.module.scss';

interface PartnersBannerContentProps {
    initialData: PartnersBannerData;
    headingId: string;
}

export const PartnersBannerContent: React.FC<PartnersBannerContentProps> = ({
    initialData,
    headingId,
}) => {
    const data = useCmsPreviewContent(initialData, {
        fetcher: useDynamicWebContentPartnersBannerQuery.fetcher,
        variables: {pageType: DynamicWebContentPageType.LoggedOutHomePage},
        adapt: adaptPartnersBannerData,
    });

    return (
        <>
            <Heading id={headingId} className={`${styles.heading} ud-heading-md`}>
                {data.heading}
            </Heading>
            <ul className={`ud-unstyled-list ${styles.logos}`}>
                {data.contents.map((partner, index) => (
                    <li key={`${partner.image.url}-${index}`} className={styles['logo-item']}>
                        <Image
                            src={partner.image.url}
                            alt={partner.image.altText}
                            className={styles.logo}
                            width="unset"
                            height="unset"
                        />
                    </li>
                ))}
            </ul>
        </>
    );
};
